import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../../shared/ErrorHandler';
import swal from 'sweetalert2';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-landrecordlist',
  templateUrl: './landrecordlist.component.html',
  styleUrls: ['./landrecordlist.component.css']
})
export class LandrecordlistComponent implements OnInit {
 
  ExtentinAcres:any;
  ExtentinGuntas:any;
  TotalAcres:any;
  TotalGuntas:any;
  total:any;
  mode: any;
  LandR_Id: any;
  PD_Id:any
  formSubmitted: boolean;
  title="Land Record List"
  show: any;
  constructor(private userService: UserService,private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) { }

  //variables declarations
  data:any;
  projectlist;
  LRremarks;
  LRProcremarks;
  LR:any={};
  LRN={};
  Land:any={};
  LR_ID;
  LR_Name;
  Survey_No;
  showIt = false;
  showMod= false;
  projectDetails:any = {};
  LandRecord:any = {};
  fileToUpload: File = null;
  Landlist: any;
  Surveylist: any;
  projId: any;
  LR_LOD_Id_Fk:any;
  userList1:any=[];
  lastkeydown1: number = 0;
  subscription: any;
  //on page load events goes into ngOnInit ()
  ngOnInit() {
    
     this.GetAllProjectforLR();
    //  this.route.params.subscribe(params =>{
    //   this.LandR_Id = params['LR_Id'];
    //   this.mode = params['mode'];
    //   this.PD_Id = params['PD_Id'];
      
    // });
    // if ((this.LandR_Id != null || this.LandR_Id !=undefined) && (this.mode!=null ||this.mode!=undefined)) 
    // {
    //   this.GetLandRecordbyId(this.LandR_Id);
      
    // }
  }

  GetLandRecordbyId(LR_Id,PD_Id) {
    this.show='Y';
    this.Land={};
    this.mode='edit';
    this.showMod = true;
     document.getElementById('loader-spinner').style.display = "block"; 
     this.userService.GetLandRecordbyId(LR_Id)
       .subscribe(
         (data:any) => {
           this.Land = data;
          //  this.GetProjectDetailsforLR(PD_Id)
          //  this.LR.PD_Id=PD_Id;
           if (this.Land.LR_Tippani_Date != null)
            this.Land.LR_Tippani_Date = ((this.Land.LR_Tippani_Date).split('T'))[0];
            if (this.Land.LR_GO_Date != null)
            this.Land.LR_GO_Date = ((this.Land.LR_GO_Date).split('T'))[0];
            if (this.Land.LR_LandConversion_Date != null)
            this.Land.LR_LandConversion_Date = ((this.Land.LR_LandConversion_Date).split('T'))[0];
            
            if(this.Land.LR_GO_File!=null)
            this.Land.LR_GO_File=data.LR_GO_File;

            if(this.Land.LR_LandConversion_File!=null)
              this.Land.LR_LandConversion_File=data.LR_LandConversion_File;

            if(this.Land.LR_Atlas!=null)
              this.Land.LR_Atlas=data.LR_Atlas;

            if(this.Land.LR_Khatha!=null)
              this.Land.LR_Khatha=data.LR_Khatha;

            if(this.Land.LR_EC!=null)
              this.Land.LR_EC=data.LR_EC;
            
            if(this.Land.LR_RTC!=null)
              this.Land.LR_EC=data.LR_RTC;

            if(this.Land.LR_Revenue_Sketch!=null)
              this.Land.LR_Revenue_Sketch=data.LR_Revenue_Sketch;
              
            if(this.Land.LR_PTSheet!=null)
              this.Land.LR_PTSheet=data.LR_PTSheet;

            if(this.Land.LR_Akar_Bandh!=null)
              this.Land.LR_Akar_Bandh=data.LR_Akar_Bandh;

            if(this.Land.LR_JMC!=null)
              this.Land.LR_JMC=data.LR_JMC;
               this.showModal();
           document.getElementById('loader-spinner').style.display = "none";
         }, (error) => {
           document.getElementById('loader-spinner').style.display = "none";
           this.errorHandler.HandlerError(error);
         });
   }

  //call and stores service and its results
  GetAllProjectforLR(){
    this.data = this.userService.GetAllProjectforLU();
    this.data.subscribe(
      (response:any) =>{
        // console.log(response);
        this.projectlist = response;
      },(error)=>{
        
      });
  }

  getUserIdsFirstWay($event) {
    let userId = (<HTMLInputElement>document.getElementById('userIdFirstWay')).value;

    if (userId.length > 2) {
      if ($event.timeStamp - this.lastkeydown1 > 200) {
        this.userList1 = this.searchFromArray(this.projectlist, userId);
      }
    }
  }  

  searchFromArray(arr, regex) {
    let matches = [], i;
    for (i = 0; i < arr.length; i++) {
      if (arr[i].match(regex)) {
        matches.push(arr[i]);
      }
    }
    return matches;
  };

  AddProject(PD_Id) {
    
    this.projId = PD_Id;
    this.LR.PD_Id=PD_Id;
    this.GetLandOwner();
    this.GetSurveyNo();
  }



  GetLandOwnerName(LR_LD_Id_Fk) {
    //let land;
    for (let i = 0; i < this.Surveylist.length; i++) {
      if (this.Surveylist[i].LD_Id == LR_LD_Id_Fk) {
        this.Land.LR_LOD_Id_Fk = this.Surveylist[i].LD_LOD_Id_Fk;
        this.LR_LOD_Id_Fk=this.Surveylist[i].LD_LOD_Id_Fk;
      }
    }
    // for (let i = 0; i < this.Landlist.length; i++) {
    //   if (this.Landlist[i].LOD_Id_PK == land) {
    //     land = this.Landlist[i].;
    //   }
    // }
  }

  GetLandOwner() {
    this.data = this.userService.GetLandOwner(this.projId);
    this.data.subscribe(
      (response: any) => {
        // console.log(response);
        this.Landlist = response;
      }, (error) => {

      });
  }

  GetSurveyNo() {
    this.data = this.userService.GetSurveyNo(this.projId);
    this.data.subscribe(
      (response: any) => {
        // console.log(response);
        this.Surveylist = response;
      }, (error) => {

      });
  }


  GetProjectDetailsforLR(projectCode){
    
    this.projectDetails ={};
    this.data = this.userService.GetProjectDetailsforLR(projectCode,2);
    this.data.subscribe(
      (response:any) => {      
        this.projectDetails = response;
        this.LandRecord = response.LandRecordDetails;
        for (let i = 0; i < this.LandRecord.length; i++) {
          if (this.LandRecord[i].LR_Tippani_Date != null)
            this.LandRecord[i].LR_Tippani_Date = ((this.LandRecord[i].LR_Tippani_Date).split('T'))[0];
        }

        this.TotalAcres = "0";
        this.TotalGuntas = "0";
        let tot_Gunt: any = 0;
        this.total = 0;
        for (let k = 0; k < this.LandRecord.length; k++) {
          if (this.LandRecord[k].LR_ExtentinAcres != null || this.LandRecord[k].LR_ExtentinGuntas != null) {
            this.ExtentinAcres = this.LandRecord[k].LR_ExtentinAcres;
            this.ExtentinGuntas = this.LandRecord[k].LR_ExtentinGuntas;
            this.TotalAcres = parseFloat(this.TotalAcres) + parseFloat(this.ExtentinAcres || 0);
            this.TotalGuntas = parseFloat(this.TotalGuntas) + parseFloat(this.ExtentinGuntas || 0);
            if (parseFloat(this.TotalGuntas) < 40) {
              tot_Gunt = '.' + parseFloat(this.TotalGuntas)
            }
            else {
              tot_Gunt = parseFloat(this.TotalGuntas) / 40;
            }
            this.total = (parseFloat(this.TotalAcres) + parseFloat(tot_Gunt));
            // this.total = (parseFloat(this.TotalAcres) + parseFloat(this.TotalGuntas)/40);
          }
        }
        // this.LR_ID = this.LandRecord.LR_Id;
      },(error) => {
      }
    );
  }


  // gettotalpercent(){
  //   
  //   this.TotalAcres.total = "0";
  //   this.TotalAcres.total = parseFloat(this.TotalAcres.total) + parseFloat(this.LandRecord.LR_ExtentinAcres || 0);
    
  //   // this.TotalAcres.total = parseFloat(this.TotalAcres.total) + parseFloat(this.HIGG.LUD_Percentage || 0)+ parseFloat(this.HIG.LUD_Percentage || 0)+ parseFloat(this.LIG.LUD_Percentage || 0)+ parseFloat(this.MIG.LUD_Percentage || 0)+ parseFloat(this.EWS.LUD_Percentage || 0);
  // }

  SendLrId(LR_Id:any,LR_Owner,Survey_no:any){
// 
this.LR_ID=LR_Id;
 this.LR_Name=LR_Owner;
 this.Survey_No=Survey_no;
 this.getRemarks(LR_Id);
 this.getProcRemarks(LR_Id);
this.showIt = true; 
 
  }

  getRemarks(LR_Id){
    
    this.data = this.userService.GetRemarks(LR_Id);
    this.data.subscribe(      
      (response:any) => {
       this.LRremarks=response;
        document.getElementById('loader-spinner').style.display = "none";
      },(error) => {
        document.getElementById('loader-spinner').style.display = "none";
      }
    );
  }
  
  getProcRemarks(LR_Id){
    
    this.data = this.userService.GetProcRemarks(LR_Id);
    this.data.subscribe(      
      (response:any) => {
       this.LRProcremarks=response;
        document.getElementById('loader-spinner').style.display = "none";
      },(error) => {
        document.getElementById('loader-spinner').style.display = "none";
      }
    );
  }

  openModal()
  {
    this.Land={};
    this.mode='save';
    this.showMod = true;
  }
  closeModal() {
    this.showIt = false;
}

closeModals() {
  this.showMod = false;
}
showModal(){
  
  this.showMod = true;
}

  onSubmit(LRN:any,LR_ID){    
    
    this.data = this.userService.AddLRNotes(LR_ID,LRN);
    this.data.subscribe(      
      (response) => {
        swal('Success!', 'saved successfully.', 'success');
        this.getRemarks(this.LR_ID);
        // this.GetProjectDetailsforLR(this.PD_Id);
        this.LRN={};
        // this.closeModal(); 
        document.getElementById('loader-spinner').style.display = "none";
      },(error) => {
        document.getElementById('loader-spinner').style.display = "none";
      }
    );
  }


  SaveLandDetails(landdetails: NgForm) {
    
    if (!landdetails.invalid) {

      document.getElementById('loader-spinner').style.display = "block";
      landdetails.value.LR_PD_ID_FK=this.LR.PD_Id;
      landdetails.value.LR_Atlas = this.getAtlasPDFUrl();
      landdetails.value.LR_Khatha = this.getKhathaPDFUrl();
      landdetails.value.LR_EC = this.getECPDFUrl();
      landdetails.value.LR_RTC = this.getRTCPDFUrl();
      landdetails.value.LR_Revenue_Sketch = this.getSketchPDFUrl();
      landdetails.value.LR_PTSheet = this.getPTSheetPDFUrl();
      landdetails.value.LR_Akar_Bandh = this.getBandhPDFUrl();
      landdetails.value.LR_JMC = this.getJMCPDFUrl();
      
      this.userService.CreateLandDetails(landdetails.value)
        .subscribe(
          (data) => {
            document.getElementById('loader-spinner').style.display = "none";
            swal('', 'Saved Successfully!', 'success');
            // this.router.navigate(['/home/planning']);
            this.GetProjectDetailsforLR(this.LR.PD_Id);
            this.LR.PD_Id=this.LR.PD_Id;
            this.Land={};
            // this.closeModals();
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            this.errorHandler.HandlerError(error);
          });
    } else
      document.getElementById('loader-spinner').style.display = "none";
    this.formSubmitted = true;
  }

  update(landdetails: NgForm) {
    
    console.log(this.Land);
     document.getElementById('loader-spinner').style.display = "block";
    //  landdetails.value.LR_PD_ID_FK=this.LR.PD_Id;
    //  landdetails.value.LR_Id=this.LandR_Id;
     if(this.Land.LR_Atlas!=null && !this.Land.LR_Atlas.match("http"))
     this.Land.LR_Atlas = this.getAtlasPDFUrl();
      if(this.Land.LR_Khatha!=null && !this.Land.LR_Khatha.match("http"))
      this.Land.LR_Khatha = this.getKhathaPDFUrl();
      if(this.Land.LR_EC!=null && !this.Land.LR_EC.match("http"))
      this.Land.LR_EC = this.getECPDFUrl();
      if(this.Land.LR_RTC!=null && !this.Land.LR_RTC.match("http"))
      this.Land.LR_RTC = this.getRTCPDFUrl();
      if(this.Land.LR_Revenue_Sketch!=null && !this.Land.LR_Revenue_Sketch.match("http"))
      this.Land.LR_Revenue_Sketch = this.getSketchPDFUrl();
      if(this.Land.LR_PTSheet!=null && !this.Land.LR_PTSheet.match("http"))
      this.Land.LR_PTSheet = this.getPTSheetPDFUrl();
      if(this.Land.LR_Akar_Bandh!=null && !this.Land.LR_Akar_Bandh.match("http"))
      this.Land.LR_Akar_Bandh = this.getBandhPDFUrl();
      if(this.Land.LR_JMC!=null && !this.Land.LR_JMC.match("http"))
      this.Land.LR_JMC = this.getJMCPDFUrl();

      if(this.Land.LR_GO_File!=null && !this.Land.LR_GO_File.match("http"))
      this.Land.LR_GO_File = this.getGOFile();
      if(this.Land.LR_LandConversion_File!=null && !this.Land.LR_LandConversion_File.match("http"))
      this.Land.LR_LandConversion_File = this.getLandFile();
      this.show='N';
     this.userService.updateLandDetails(this.Land)
       .subscribe(
         (data) => {
           document.getElementById('loader-spinner').style.display = "none";
           swal('','Updated Successfully!','success');
          //  this.GetProjectDetailsforLR(this.PD_Id);
          this.GetProjectDetailsforLR(this.LR.PD_Id);
          this.LR.PD_Id=this.LR.PD_Id;
          this.Land={};
            // this.router.navigate(['/home/landrecord']);
            
         }, (error) => {
           document.getElementById('loader-spinner').style.display = "none";
           this.errorHandler.HandlerError(error);
         });
   }

  //  updated(Land: any) {
  //   
  //    document.getElementById('loader-spinner').style.display = "block";
  //   //  Land.value.LR_PD_ID_FK=this.LR.PD_Id;
  //   //  Land.value.LR_Id=this.LandR_Id;
  //    if(Land.LR_Atlas==null)
  //    Land.LR_Atlas = this.getAtlasPDFUrl();
  //     if(Land.LR_Khatha==null)
  //     Land.LR_Khatha = this.getKhathaPDFUrl();
  //     if(Land.LR_EC==null)
  //     Land.LR_EC = this.getECPDFUrl();
  //     if(Land.LR_RTC==null)
  //     Land.LR_RTC = this.getRTCPDFUrl();
  //     if(Land.LR_Revenue_Sketch==null)
  //     Land.LR_Revenue_Sketch = this.getSketchPDFUrl();
  //     if(Land.LR_PTSheet==null)
  //     Land.LR_PTSheet = this.getPTSheetPDFUrl();
  //     if(Land.LR_Akar_Bandh==null)
  //     Land.LR_Akar_Bandh = this.getBandhPDFUrl();
  //     if(Land.LR_JMC==null)
  //     Land.LR_JMC = this.getJMCPDFUrl();
  //    this.userService.updateLandDetails(Land)
  //      .subscribe(
  //        (data) => {
  //          document.getElementById('loader-spinner').style.display = "none";
  //          swal('','Updated Successfully!','success');
  //         //  this.router.navigate(['/home/planning']);
  //        }, (error) => {
  //          document.getElementById('loader-spinner').style.display = "none";
  //          this.errorHandler.HandlerError(error);
  //        });
  //  }

  UploadAtlas(file: FileList) {

    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 40000)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      // reader.onload = (event: any) => {
      //   this.FeasibilityPDFUrl = event.target.result;
      // }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          // console.log(response);
          // this.app.APP_PA_PhotoErrorMessage="";

        }, (error) => {
          let i: any = document.getElementById('LR_Atlas');
          i.value = "";
          if (error.status == 400) {
            // this.FeasibilityPDFUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('LR_Atlas');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }



  getAtlasPDFUrl() {
    let imagename = null;
    try {
      imagename = document.getElementById('LR_Atlas');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  UploadKhatha(file: FileList) {

    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 40000)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      // reader.onload = (event: any) => {
      //   this.FeasibilityPDFUrl = event.target.result;
      // }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          // console.log(response);
          // this.app.APP_PA_PhotoErrorMessage="";

        }, (error) => {
          let i: any = document.getElementById('LR_Khatha');
          i.value = "";
          if (error.status == 400) {
            // this.FeasibilityPDFUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('LR_Khatha');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }



  getKhathaPDFUrl() {
    let imagename = null;
    try {
      imagename = document.getElementById('LR_Khatha');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }
  UploadEC(file: FileList) {

    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 40000)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      // reader.onload = (event: any) => {
      //   this.FeasibilityPDFUrl = event.target.result;
      // }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          // console.log(response);
          // this.app.APP_PA_PhotoErrorMessage="";

        }, (error) => {
          let i: any = document.getElementById('LR_EC');
          i.value = "";
          if (error.status == 400) {
            // this.FeasibilityPDFUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('LR_EC');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }



  getECPDFUrl() {
    let imagename = null;
    try {
      imagename = document.getElementById('LR_EC');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }
  UploadRTC(file: FileList) {

    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 40000)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      // reader.onload = (event: any) => {
      //   this.FeasibilityPDFUrl = event.target.result;
      // }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          // console.log(response);
          // this.app.APP_PA_PhotoErrorMessage="";

        }, (error) => {
          let i: any = document.getElementById('LR_RTC');
          i.value = "";
          if (error.status == 400) {
            // this.FeasibilityPDFUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('LR_RTC');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }



  getRTCPDFUrl() {
    let imagename = null;
    try {
      imagename = document.getElementById('LR_RTC');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }
  UploadSketch(file: FileList) {

    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 40000)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      // reader.onload = (event: any) => {
      //   this.FeasibilityPDFUrl = event.target.result;
      // }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          // console.log(response);
          // this.app.APP_PA_PhotoErrorMessage="";

        }, (error) => {
          let i: any = document.getElementById('LR_Revenue_Sketch');
          i.value = "";
          if (error.status == 400) {
            // this.FeasibilityPDFUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('LR_Revenue_Sketch');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }



  getSketchPDFUrl() {
    let imagename = null;
    try {
      imagename = document.getElementById('LR_Revenue_Sketch');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }
  UploadPTSheet(file: FileList) {

    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 40000)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      // reader.onload = (event: any) => {
      //   this.FeasibilityPDFUrl = event.target.result;
      // }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          // console.log(response);
          // this.app.APP_PA_PhotoErrorMessage="";

        }, (error) => {
          let i: any = document.getElementById('LR_PTSheet');
          i.value = "";
          if (error.status == 400) {
            // this.FeasibilityPDFUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('LR_PTSheet');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }



  getPTSheetPDFUrl() {
    let imagename = null;
    try {
      imagename = document.getElementById('LR_PTSheet');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }
  UploadBandh(file: FileList) {

    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 40000)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      // reader.onload = (event: any) => {
      //   this.FeasibilityPDFUrl = event.target.result;
      // }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          // console.log(response);
          // this.app.APP_PA_PhotoErrorMessage="";

        }, (error) => {
          let i: any = document.getElementById('LR_Akar_Bandh');
          i.value = "";
          if (error.status == 400) {
            // this.FeasibilityPDFUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('LR_Akar_Bandh');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }



  getBandhPDFUrl() {
    let imagename = null;
    try {
      imagename = document.getElementById('LR_Akar_Bandh');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }
  UploadJMC(file: FileList) {

    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 40000)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      // reader.onload = (event: any) => {
      //   this.FeasibilityPDFUrl = event.target.result;
      // }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          // console.log(response);
          // this.app.APP_PA_PhotoErrorMessage="";

        }, (error) => {
          let i: any = document.getElementById('LR_JMC');
          i.value = "";
          if (error.status == 400) {
            // this.FeasibilityPDFUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('LR_JMC');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }



  getJMCPDFUrl() {
    let imagename = null;
    try {
      imagename = document.getElementById('LR_JMC');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  UploadGOFile(file: FileList) {

    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 40000)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      // reader.onload = (event: any) => {
      //   this.FeasibilityPDFUrl = event.target.result;
      // }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          // console.log(response);
          // this.app.APP_PA_PhotoErrorMessage="";

        }, (error) => {
          let i: any = document.getElementById('LR_GO_File');
          i.value = "";
          if (error.status == 400) {
            // this.FeasibilityPDFUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('LR_GO_File');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }



  getGOFile() {
    let imagename = null;
    try {
      imagename = document.getElementById('LR_GO_File');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  UploadLandFile(file: FileList) {

    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 40000)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      // reader.onload = (event: any) => {
      //   this.FeasibilityPDFUrl = event.target.result;
      // }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          // console.log(response);
          // this.app.APP_PA_PhotoErrorMessage="";

        }, (error) => {
          let i: any = document.getElementById('LR_LandConversion_File');
          i.value = "";
          if (error.status == 400) {
            // this.FeasibilityPDFUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('LR_LandConversion_File');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }



  getLandFile() {
    let imagename = null;
    try {
      imagename = document.getElementById('LR_LandConversion_File');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/planning/land-record/landrecordlist/landrecordlist.component.ts